module.exports = __webpack_public_path__ + "media/images/flags/cr-982f8c0e3ab7cd19b88d228fdddae0d5.svg";